<template>
  <b-dropdown
    split
    :split-variant="color"
    :application="application"
    :variant="color + ' active'"
    size="sm"
    right
    target="_blank"
    ref="dropdown"
  >
    <template slot="button-content">
      <span><font-awesome-icon icon="file-signature" /></span>
      <span>{{fileText}}</span>
    </template>
    <b-dropdown-form>
        <label @click="initFileUpload()" ref="uploadLabel" class="cloud-download-alt">
          <span class="icon"><font-awesome-icon icon="cloud-upload-alt"/></span>
          <span>{{t('Upload')}}</span>
          <input type="file" id="file" ref="file"  v-on:change="handleFileUpload()" />
        </label>
    </b-dropdown-form>
    <b-dropdown-item v-show="this.application.signedDocumentExists" :href="application.signedAppLinkSend" target="_blank">
      <span class="icon"><font-awesome-icon icon="paper-plane"/></span>
      <span>
      <accept-action :buttonName="this.application.submitDate === null ? t('Send') : t('Send again')"
                     :modalText="t('Do you want to send applications to insurance?')"
                     button-class="btn-link"
                     buttonIcon="paper-plane"
                     modalIcon="paper-plane"
                     @accepted="sendApplication()"
      />
      </span>
    </b-dropdown-item>
    <b-dropdown-item v-show="this.application.signedDocumentExists" :href="application.signedAppLinkDownload" target="_blank">
      <span class="icon"><font-awesome-icon icon="file-download"/></span>
      <span>{{t('Download')}}</span>
    </b-dropdown-item>
    <b-dropdown-item v-show="this.application.signedDocumentExists" v-on:click="removeFile()">
      <span class="icon"><font-awesome-icon icon="times-circle"/></span>
      <span>{{t('Remove')}}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
    import AcceptAction from '../../../core/AcceptAction';
    import Loading from '../../../core/Components/loading';

    export default {
        components: {
            AcceptAction,
            Loading
        },
        name: 'signed-document-upload',
        props: {
            application: {
                type: Object,
                required: true,
            },
            color: {
                type: String,
                required: false,
                default: 'success'
            }
        },
        methods: {
            initFileUpload() {
                this.$refs.dropdown.hide(true);
            },
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('applicationId', this.$route.params.id);
                this.$store.dispatch('applications/uploadSigned', formData).then(response => {
                    this.application.signedDocumentExists = true;
                    this.application.signedDocumentName = response.filename;
                })
            },
            removeFile() {
                this.$store.dispatch('applications/removeSigned', this.application.fileHash).then(response => {
                    this.application.signedDocumentExists = false;
                })
            },
            sendApplication() {
                this.openModal = true;
                this.$store.dispatch('applications/sendApplication', this.application.id).then(res => {
                    this.openModal = false;
                    this.$emit('sent');
                }).catch(res => {
                    this.openModal = false;
                });
            }
        },
        computed: {
            fileText: function() {
                if (this.application.signedDocumentExists) {
                    return this.application.signedDocumentName;
                }
                else {
                    return this.t('Upload signed application');
                }
            }
        },
        data() {
            return {
                file: '',
                componentKey: 0,
                openModal: false
            }
        }

    }
</script>

<style>
  input[type="file"] {
    position: absolute;
    top: -500px;
  }
  label.cloud-download-alt {
    margin-bottom: 0;
    cursor: pointer;
  }
  form.b-dropdown-form {
    padding: .25rem 1.5rem;
  }
  .dropdown-menu span.icon {
    display:block;
    float:left;
    width:30px;
    padding-left: 4px;
  }
  .b-dropdown li:hover {
    background-color:#dadada;
  }
  .b-dropdown li a:hover {
    background-color:#dadada;
  }
  .b-dropdown li .svg-inline--fa {
     color:#35495e;
  }
  .dropdown-menu button {
    color:#35495e;
    background: transparent;
  }
  .dropdown-menu button svg {
    display:none;
  }
  .dropdown-menu .dropdown-item {
    overflow: hidden;
  }
</style>
<style lang="scss">
  .dropdown-menu .btn-link {
    color: inherit !important;
    padding:0 !important;
    &:hover {
      color: inherit !important;
      text-decoration: none !important;
      padding:0 !important;
    }
    &:focus {
      border:0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/signed-document-upload.vue